interface SkeletonProps { height?: number; width?: string | number; radius?: number; style?: React.CSSProperties }

/** Skeletons, never a giant blocking spinner. §127 */
export function Skeleton({ height = 16, width = '100%', radius = 8, style }: SkeletonProps) {
  return (
    <div
      className="skeleton"
      style={{ height, width, borderRadius: radius, ...style }}
      aria-hidden="true"
    />
  );
}

export function SkeletonCard({ lines = 3 }: { lines?: number }) {
  return (
    <div className="card stack" aria-busy="true" aria-live="polite">
      <Skeleton height={12} width="34%" />
      <Skeleton height={34} width="58%" />
      {Array.from({ length: lines - 1 }).map((_, i) => (
        <Skeleton key={i} height={12} width={`${70 - i * 12}%`} />
      ))}
      <span className="sr-only">טוען…</span>
    </div>
  );
}
